var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"自費テンプレート","headers":_vm.selfburdenTemplateHeaders,"items":_vm.items},on:{"makenew":_vm.selfburdenTemplateCreate,"repair":_vm.selfburdenTemplateEdit,"copy":_vm.selfburdenTemplateCopy}})}
var staticRenderFns = []

export { render, staticRenderFns }